import text from './text.json'
import './index.scss'
import {PaidIcon} from '../../../icons'
import {useDispatch, useSelector} from 'react-redux'
import {logUpgradePlanNavigation} from '../../../stores/customer-settings'
import {Link} from 'react-router-dom'
import {routes} from '../../../routes'
import classNames from 'classnames'

const ForPaid = ({forPaidText, isExceeded, isInfo = false, className = ''}) => {
    const dispatch = useDispatch()
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    const postAction = () => {
        dispatch(logUpgradePlanNavigation())
    }

    return (
        <div className={classNames({
            'for-paid': true,
            'exceeded': isExceeded,
            'dark': isDarkMode
        }, className
        )}>
            {!isInfo && (
                <span className="paid-icon">
                    <PaidIcon/>
                </span>
            )}
            <p className="for-paid-text">{forPaidText} {
                !isInfo && (
                    <>
                        <Link onClick={postAction} to={routes.plans.path}>{text.upgrade_plan}</Link>
                        <span> or contact </span>
                        <a href={`mailto:${text.email}`}>{text.email}.</a>
                    </>
                )
            }
            </p>
        </div>
    )
}

export default ForPaid
